import { Type } from '@sinclair/typebox';
import { cartAddressSchema, cartLineSchema } from "./cart/index.mjs";
import { priceSchema } from "./price.mjs";
const orderAddressSchema = Type.Omit(cartAddressSchema, ['isValid']);
export const orderSchema = Type.Object({
    id: Type.String(),
    cartId: Type.String(),
    address: orderAddressSchema,
    useBillingAddress: Type.Boolean(),
    billingAddress: Type.Optional(orderAddressSchema),
    lines: Type.Array(cartLineSchema),
    total: priceSchema,
    paymentFailed: Type.Boolean(),
});
export const orderResponseSchema = Type.Object({
    order: orderSchema,
});
//# sourceMappingURL=order.js.map